import { Card, CardContent, Grid, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import { getStudentsPartial } from "framework/students/students_partial";
import { useMaterialUIController } from "context";
import BardcodeScannerCard from "components/BarcodeScannerCard";

const InputField = styled(MDInput)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid #bababa",
    },
  },
});

const AttendanceInOutInptCard = ({ setStudentData, setSnackbar, studentCardRef }) => {
  const [admissionNo, setAdmissionNo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uicontrol] = useMaterialUIController();

  async function getStudentWithAdmissionNo(e) {
    e.preventDefault();
    if (!admissionNo || isLoading) return;
    try {
      setIsLoading(true);
      const student = await getStudentsPartial(admissionNo);
      setAdmissionNo(null);
      setStudentData(student);
      setTimeout(() => {
        studentCardRef.current?.scrollIntoView();
      }, 0);
    } catch (err) {
      let msg = "Something went wrong, failed to find the student.";
      setStudentData(null);
      setSnackbar({
        desc: err?.message ?? msg,
        type: "error",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }
  return (
    <>
      <Grid container my={5}>
        <Grid lg={3} md={1} xs={0} item />
        <Grid lg={6} md={10} xs={12} item>
          <Card sx={{ textAlign: "center" }} raised>
            <MDBox p={1}>
              <CardContent>
                <Grid item xs={12} md={12} lg={12}>
                  <MDTypography variant="h2">Checkin-out</MDTypography>
                </Grid>
                <form onSubmit={getStudentWithAdmissionNo}>
                  <Grid py={3} container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                      <InputField
                        required
                        fullWidth
                        variant="outlined"
                        label="Admission No"
                        value={admissionNo ?? ""}
                        onChange={(e) => {
                          setAdmissionNo(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <MDButton
                        type="submit"
                        fullWidth
                        variant="gradient"
                        color={uicontrol.sidenavColor}
                        sx={{ height: "40px" }}
                        disabled={isLoading}
                      >
                        {isLoading ? <CircularProgress color="light" /> : "Submit"}
                      </MDButton>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <MDTypography variant="h6">OR</MDTypography>
                    </Grid>
                    <BardcodeScannerCard
                      onBarcodeDetected={(code) => {
                        setAdmissionNo(code);
                        getStudentWithAdmissionNo();
                      }}
                    />
                  </Grid>
                </form>
              </CardContent>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default AttendanceInOutInptCard;
